<div class="flex h-full flex-col px-3 py-2">
  <div class="shrink-0 mb-2">
    <h2 class="text-sm font-semibold text-slate-700">Últimos pagos</h2>
    <p class="text-xs text-slate-400">Cargos pagados en el período</p>
  </div>
  @if ((data()?.recentPayments?.length ?? 0) === 0) {
    <div class="flex-1 flex items-center justify-center text-slate-400 text-sm">
      No hay pagos en este período
    </div>
  } @else {
    <ul class="flex-1 min-h-0 overflow-y-auto space-y-1.5">
      @for (charge of data()?.recentPayments; track trackCharge($index, charge)) {
        <li class="flex items-center justify-between gap-2 text-sm border-b border-slate-100 pb-1.5 last:border-0">
          <div class="min-w-0">
            <a [routerLink]="['/invoices', charge.invoiceId]"
               class="font-medium text-slate-800 hover:text-blue-600 truncate block text-xs">
              {{ charge.invoice?.number ?? ('#' + charge.invoiceId) }}
            </a>
            <span class="text-xs text-slate-400">{{ formatDate(charge.paidAt) }}</span>
          </div>
          <span class="font-semibold text-emerald-700 shrink-0 tabular-nums text-sm">
            {{ formatCurrency(charge.total ?? 0) }}
          </span>
        </li>
      }
    </ul>
  }
</div>
